import { render } from "./CorporateDashboard.vue?vue&type=template&id=061e66e4&scoped=true"
import script from "./CorporateDashboard.vue?vue&type=script&lang=js"
export * from "./CorporateDashboard.vue?vue&type=script&lang=js"

import "./CorporateDashboard.vue?vue&type=style&index=0&id=061e66e4&lang=css"
import "./CorporateDashboard.vue?vue&type=style&index=1&id=061e66e4&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061e66e4"]])

export default __exports__